// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"9edc13f3","57":"d46f1c27","227":"3591c465","985":"7aee8ec5","989":"711ddada","993":"d78c2725"}[chunkId] + ".chunk.js";
};